import React, {Component} from 'react';
import {Switch, Route} from 'react-router-dom'
import "./css/newFeesie.css";
class newFeesie extends Component{
    render() {
        return <div className="new-feesie">
        <div className="main-content">
        </div>
        </div>
    }
    
}
export default newFeesie;


// WEBPACK FOOTER //
// ./src/newFeesie.js